import {requirePermission} from '@/modules/auth/permissions'
import {NewCompanyPageSearchSchema} from '@/modules/products/companies/schemas'
import {NewResourceFormContainer} from '@cypro/ui/components/ui/new-resource-form-container'
import {NewResourceFormHeader} from '@cypro/ui/components/ui/new-resource-form-header'
import {createFileRoute} from '@tanstack/react-router'
import {useTranslate} from '@tolgee/react'

export const Route = createFileRoute('/configuration/products/companies/new')({
  beforeLoad: requirePermission('basic_data.manage'),
  component: NewCompanyPage,
  validateSearch: NewCompanyPageSearchSchema,
})

function NewCompanyPage() {
  const {t} = useTranslate('companies')
  const {companyId} = Route.useSearch()

  return (
    <NewResourceFormContainer>
      <NewResourceFormHeader
        title={companyId ? t('edit_company_title') : t('new_company_title')}
        description={t('new_company_description')}
      />
    </NewResourceFormContainer>
  )
}
